import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { withTheme } from 'styled-components';

import { selectBookingStep, BookingActions, selectIsStepFilled } from '../../modules/booking';
import { Booking } from './booking.component';
import { selectCurrentExperience, selectCurrentExperienceHomeRoute } from '../../modules/experience';

const mapStateToProps = createStructuredSelector({
  step: selectBookingStep,
  experienceHomeUrl: selectCurrentExperienceHomeRoute,
  experience: selectCurrentExperience,
  isStepFilled: selectIsStepFilled,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      startBooking: BookingActions.startBooking,
      nextStep: BookingActions.requestNextStep,
      previousStep: BookingActions.previousStep,
      resetBooking: BookingActions.clearBooking,
      closeBooking: BookingActions.closeBooking,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withTheme
)(Booking);
